// Merkan · Englisches Wörterbuch Paket 6: Einkauf und Logistik (Bereitstellung, Erinnerungen, Bewertung, Versanddienstleister, Sendungsverfolgung)
export default {
  "100 = Durchschnitt der Mitbewerber, aus {n} Vergleich": "100 = average of competitors, from {n} comparison",
  "100 = Durchschnitt der Mitbewerber, aus {n} Vergleichen": "100 = average of competitors, from {n} comparisons",
  "12 Monate": "12 months",
  "24 Monate": "24 months",
  "5 Jahre": "5 years",
  "6 Monate": "6 months",
  "AB nach {n} Werktagen": "OA after {n} working days",
  "AB-Reaktionszeit": "Acknowledgement response time",
  "API-Key": "API key",
  "Abholanschrift": "Collection address",
  "Abholauftrag an {mail}": "Collection orders to {mail}",
  "Abholauftrag an {name}": "Collection order to {name}",
  "Abholauftrag gesendet, Abholung gebucht.": "Collection order sent, collection booked.",
  "Abholauftrag per Mail": "Collection order by email",
  "Abholauftrag senden": "Send collection order",
  "Abholaufträge an": "Collection orders to",
  "Abholbereit ab": "Ready for collection from",
  "Abholdatum": "Collection date",
  "Abholland: {land}": "Collection country: {land}",
  "Abholung am": "Collection on",
  "Abholung buchen": "Book collection",
  "Abholung durch {name}": "Collection by {name}",
  "Abholung gebucht": "Collection booked",
  "Abholung gebucht.": "Collection booked.",
  "Abholung nicht gebucht": "Collection not booked",
  "Abholung offen": "Collection open",
  "Abholung über die Schnittstelle buchen. Zugang beim DHL-Express-Kundenbetreuer beantragen.": "Book collections via the interface. Request access from your DHL Express account manager.",
  "Abholung": "Collection",
  "Abrechnung": "Billing",
  "Alle Lieferanten sind erinnert. Neue Vorschläge erscheinen nach Ablauf der Frist.": "All suppliers have been reminded. New suggestions appear once the deadline has passed.",
  "An den Kunden": "To the customer",
  "An uns": "To us",
  "An {n} Spediteur senden": "Send to {n} forwarder",
  "An {n} Spediteure senden": "Send to {n} forwarders",
  "Andere Anschrift": "Other address",
  "Anfrage abbrechen": "Cancel enquiry",
  "Anfrage an mehrere Spediteure per Mail, Angebote nebeneinander vergleichen und beauftragen.": "Send an enquiry to several forwarders by email, compare quotations side by side and place the order.",
  "Anfrage per Mail an mehrere Spediteure": "Enquiry by email to several forwarders",
  "Anfrage senden": "Send enquiry",
  "Angaben übernommen ({p} % sicher). Bitte prüfen und speichern.": "Details taken over ({p} % certain). Please check and save.",
  "Angebot da": "Quotation received",
  "Angebot von {name} gespeichert.": "Quotation from {name} saved.",
  "Angebot": "Quotation",
  "Angebotsvergleich": "Quotation comparison",
  "Anschrift, Schiff oder Agent": "Address, vessel or agent",
  "Ansprechpartner vor Ort": "Contact on site",
  "Antwort des Spediteurs wählen": "Select forwarder's reply",
  "Antwortmail wählen": "Select reply email",
  "Anz.": "Qty",
  "Anzahl": "Quantity",
  "Auftragsbestätigung fehlt nach": "Order acknowledgement missing after",
  "Auftragsbestätigung fehlt": "Order acknowledgement missing",
  "Aus dem Stamm wählen": "Select from master data",
  "Automatisch abfragen": "Query automatically",
  "Automatische Abläufe": "Automated processes",
  "Automatische Verfolgung stündlich": "Automatic tracking every hour",
  "Automatische Verfolgung, zuletzt abgefragt {zeit}": "Automatic tracking, last queried {zeit}",
  "B": "W",
  "Beauftragen": "Place order",
  "Beauftragt. Die Sendung steht im Reiter Logistik des Vorgangs.": "Ordered. The shipment is listed on the Logistics tab of the case.",
  "Beim Wählen des Angebots werden leere Felder im Artikelstamm automatisch ergänzt.": "When the quotation is selected, empty fields in the article master are filled automatically.",
  "Benachrichtigung zur Sendungsverfolgung": "Shipment tracking notifications",
  "Benutzer": "User",
  "Bereit": "Ready",
  "Bereitstellung bearbeiten": "Edit readiness",
  "Bereitstellung erfassen": "Record readiness",
  "Bereitstellung erfragen": "Ask for readiness",
  "Bereitstellung offen": "Readiness open",
  "Bereitstellung speichern": "Save readiness",
  "Bereitstellung zu {nummer} erfasst.": "Readiness for {nummer} recorded.",
  "Bereitstellung zur Bestellung erfassen": "Record readiness for the order",
  "Bereitstellung zurückgenommen.": "Readiness withdrawn.",
  "Bereitstellung zurücknehmen?": "Withdraw readiness?",
  "Bereitstellung": "Readiness",
  "Bereitstellungsmeldung": "Readiness notice",
  "Bestellung wählen": "Select order",
  "Bestellung über den Lieferanten zugeordnet, keine Bestellnummer in der Meldung.": "Order assigned via the supplier, no order number in the notice.",
  "Bestellung": "Order",
  "Bestellungen entstehen in der Beschaffung, Sendungen beim Versand oder bei einer Abholung.": "Orders are created in procurement, shipments when dispatching or when a collection is booked.",
  "Bestellungen": "Orders",
  "Bewertung {p}": "Rating {p}",
  "Bewertung": "Rating",
  "Bis": "To",
  "Bitte Abholung und Ziel angeben.": "Please enter collection and destination.",
  "Bitte auch {feld} eingeben.": "Please also enter {feld}.",
  "Bitte den vollständigen Schlüssel eingeben.": "Please enter the complete key.",
  "Bitte die Bestellung wählen, zu der die Ware bereitsteht.": "Please select the order for which the goods are ready.",
  "Bitte eine Mail wählen oder den Text einfügen.": "Please select an email or paste the text.",
  "Bitte eine gültige Mailadresse angeben.": "Please enter a valid email address.",
  "Bitte einen Namen angeben.": "Please enter a name.",
  "Bitte einen Namen für die Zone angeben.": "Please enter a name for the zone.",
  "Bitte einen Titel angeben.": "Please enter a title.",
  "Bitte einen Versanddienstleister wählen.": "Please select a carrier.",
  "Bitte mindestens einen Spediteur wählen.": "Please select at least one forwarder.",
  "Bitte zuerst die Antwortmail wählen.": "Please select the reply email first.",
  "Breite cm": "Width cm",
  "Client-ID": "Client ID",
  "Client-Secret": "Client secret",
  "Das Gewicht bitte als Zahl in kg angeben.": "Please enter the weight as a number in kg.",
  "Das Ursprungsland bitte als zweistelligen Ländercode angeben, z. B. DE.": "Please enter the country of origin as a two-letter code, e.g. DE.",
  "Der Preisvergleich ist nicht möglich.": "The price comparison is not possible.",
  "Der Test ist fehlgeschlagen.": "The test failed.",
  "Der Test ist hier nicht verfügbar.": "The test is not available here.",
  "Der Text konnte nicht ausgelesen werden.": "The text could not be read.",
  "Der Verfolgungslink beginnt mit https:// und enthält {nummer} für die Sendungsnummer.": "The tracking link starts with https:// and contains {nummer} for the tracking number.",
  "Der Volumenteiler liegt zwischen 1000 und 10000 (üblich 5000, Spedition 3000, Luftfracht 6000).": "The volume divisor is between 1000 and 10000 (usually 5000, road freight 3000, air freight 6000).",
  "Die Abfrage ist fehlgeschlagen.": "The query failed.",
  "Die Abfrage konnte gerade nicht ausgeführt werden.": "The query could not be run at the moment.",
  "Die Antwort konnte nicht ausgelesen werden.": "The reply could not be read.",
  "Die Anzahl Colli bitte als ganze Zahl angeben.": "Please enter the number of packages as a whole number.",
  "Die Bestellung gilt wieder als bestätigt, die Angaben zur Abholung werden entfernt.": "The order is treated as confirmed again, the collection details are removed.",
  "Die Buchung ist fehlgeschlagen.": "The booking failed.",
  "Die Buchung über die Schnittstelle ist hier nicht verfügbar. Bitte den Abholauftrag per Mail senden.": "Booking via the interface is not available here. Please send the collection order by email.",
  "Die Meldung konnte nicht ausgelesen werden.": "The notice could not be read.",
  "Die Nachricht sieht nicht wie eine Bereitstellungsmeldung aus. Bitte die Angaben prüfen.": "The message does not look like a readiness notice. Please check the details.",
  "Die Sendungsverfolgung ist hier nicht verbunden.": "Shipment tracking is not connected here.",
  "Die Tarife der Zone werden mit gelöscht.": "The rates of this zone are deleted as well.",
  "Die Zolltarifnummer hat 6 bis 11 Ziffern, z. B. 8409 91 00.": "The customs tariff number has 6 to 11 digits, e.g. 8409 91 00.",
  "Dienstleister anlegen": "Add carrier",
  "Dienstleister bearbeiten": "Edit carrier",
  "Dienstleister": "Carrier",
  "Diese Mail mit {ki} lesen": "Read this email with {ki}",
  "Dieser Dienstleister existiert nicht oder ist für dich nicht sichtbar.": "This carrier does not exist or is not visible to you.",
  "EK pro Stück": "Purchase price per unit",
  "Ein Dienstleister mit diesem Namen existiert bereits.": "A carrier with this name already exists.",
  "Eine Zone fasst Länder mit gleichen Preisen zusammen. Eine Zone ohne Länder gilt für alle übrigen Länder.": "A zone groups countries with the same rates. A zone without countries applies to all other countries.",
  "Einkauf und Versand": "Purchasing and shipping",
  "Einstellungen gespeichert.": "Settings saved.",
  "Einstellungen, Einkauf und Versand": "Settings, purchasing and shipping",
  "Empfehlung wählen": "Select recommendation",
  "Empfehlung": "Recommendation",
  "Empfehlung: {name}": "Recommendation: {name}",
  "Erinnerung senden": "Send reminder",
  "Erinnerungen an Lieferanten": "Reminders to suppliers",
  "Erinnerungen an Lieferanten, Angebotsvergleich, Sendungsverfolgung und Zugänge der Versanddienstleister.": "Reminders to suppliers, quotation comparison, shipment tracking and carrier access.",
  "Erinnerungen an den Lieferanten": "Reminders to the supplier",
  "Erneut erinnern nach": "Remind again after",
  "Ersetzen": "Replace",
  "Etikett": "Label",
  "Etiketten": "Labels",
  "Express-Kundennummer": "Express account number",
  "Fehler": "Error",
  "Firmenanschrift in den Einstellungen fehlt": "Company address missing in the settings",
  "Fracht": "Freight",
  "Fragt ab …": "Querying …",
  "Für den Preisvergleich bitte das Gewicht angeben.": "For the price comparison, please enter the weight.",
  "Für den Preisvergleich bitte das Land als zweistelligen Code angeben, z. B. NL.": "For the price comparison, please enter the country as a two-letter code, e.g. NL.",
  "Für die Logistik fehlt deiner Rolle das Recht.": "Your role has no permission for logistics.",
  "Für diesen Dienstleister ist keine Schnittstelle eingerichtet. Bitte über den Link verfolgen und die Zustellung von Hand bestätigen.": "No interface is set up for this carrier. Please track via the link and confirm delivery manually.",
  "Für {name} ist keine Mailadresse für Abholaufträge hinterlegt.": "No email address for collection orders is stored for {name}.",
  "Gemeldet": "Reported",
  "Gewicht gesamt kg": "Total weight kg",
  "Gewicht je Stück kg": "Weight per package kg",
  "Gewichtsstufe": "Weight band",
  "Gewichtung der Punktzahl je Angebot. Jeder Benutzer kann die Gewichtung in der Kalkulation für sich ändern.": "Weighting of the score per quotation. Each user can change the weighting for themselves in the costing.",
  "Gewichtung": "Weighting",
  "Gewählt: {name}": "Selected: {name}",
  "Gut": "Good",
  "Gültig bis": "Valid until",
  "H": "H",
  "Hinweis für die Abholung": "Note for the collection",
  "Hinweis": "Note",
  "Höhe cm": "Height cm",
  "Immer automatisch benachrichtigen": "Always notify automatically",
  "In der Mail wurde kein Preis gefunden. Bitte prüfen.": "No price was found in the email. Please check.",
  "Inland": "Domestic",
  "Jede Tarifzeile braucht ein Gewicht bis und einen Preis.": "Every rate line needs a weight limit and a price.",
  "Jedes Gewicht darf je Zone nur einmal vorkommen.": "Each weight may only occur once per zone.",
  "Jetzt abfragen": "Query now",
  "Jetzt ausführen": "Run now",
  "Kein Dienstleister gefunden": "No carrier found",
  "Keine Bewertung möglich": "No rating possible",
  "Keine Versanddienstleister im Stamm.": "No carriers in master data.",
  "Keine Versanddienstleister mit Tarifen hinterlegt.": "No carriers with rates stored.",
  "Keine eingegangene Mail im Vorgang, Text unten einfügen": "No incoming email in the case, paste text below",
  "Keine offene Bestellung": "No open order",
  "Keine offenen Erinnerungen und noch keine gesendet.": "No open reminders and none sent yet.",
  "Kontakt und Aufträge": "Contact and orders",
  "Kunden automatisch benachrichtigen": "Notify customers automatically",
  "Kundennummer": "Account number",
  "Kurier": "Courier",
  "L": "L",
  "Land für die Tarifzone": "Country for the rate zone",
  "Land": "Country",
  "Laufzeit Tage": "Transit days",
  "Laufzeit": "Transit time",
  "Leer: E-Mail": "Empty: email",
  "Lieferant meldet Ware abholbereit": "Supplier reports goods ready for collection",
  "Lieferanten-Bezeichnung": "Supplier description",
  "Lieferanten-Nr.": "Supplier part no.",
  "Lieferantenbewertung {p}": "Supplier rating {p}",
  "Lieferantenbewertung": "Supplier rating",
  "Lieferantenmail wählen": "Select supplier email",
  "Liefertermin überschritten": "Delivery date overdue",
  "Liefertreue {p} %": "Delivery reliability {p} %",
  "Liefertreue": "Delivery reliability",
  "Lieferzeit {p}": "Lead time {p}",
  "Logistik": "Logistics",
  "Luftfracht": "Air freight",
  "Länder": "Countries",
  "Ländercodes mit Komma, leer = alle übrigen Länder": "Country codes separated by commas, empty = all other countries",
  "Länge cm": "Length cm",
  "Läuft …": "Running …",
  "Mail aus dem Sammelpostfach in Kundensprache. Je Kunde abweichend einstellbar.": "Email from the shared mailbox in the customer's language. Can be set differently per customer.",
  "Mail aus dem Vorgang wählen oder Text unten einfügen": "Select an email from the case or paste text below",
  "Mail aus dem Vorgang wählen": "Select an email from the case",
  "Mail für Abholaufträge": "Email for collection orders",
  "Mail in Sprache des Lieferanten sofort senden": "Send email in the supplier's language now",
  "Mail lesen": "Read email",
  "Mail mit {ki} lesen": "Read email with {ki}",
  "Mail wählen": "Select email",
  "Maße je Packstück in cm": "Dimensions per package in cm",
  "Maße: {m}": "Dimensions: {m}",
  "Mehrere Bestellungen passen, bitte oben wählen.": "Several orders match, please select above.",
  "Meldung des Lieferanten mit {ki} auslesen": "Read the supplier's notice with {ki}",
  "Meldung erfassen": "Add status message",
  "Mit {ki} lesen": "Read with {ki}",
  "Mittel": "Medium",
  "Mo bis Fr 8 bis 16 Uhr": "Mon to Fri 8 am to 4 pm",
  "Muster mit {nummer} für die Sendungsnummer; leer: bekannter Link nach Name": "Pattern with {nummer} for the tracking number; empty: known link by name",
  "Nachbau": "Replacement part",
  "Name, Kundennummer oder Mail": "Name, account number or email",
  "Neue Anfrage": "New enquiry",
  "Neuer Dienstleister": "New carrier",
  "Neuer Versanddienstleister": "New carrier",
  "Nicht gefunden": "Not found",
  "Nie automatisch benachrichtigen": "Never notify automatically",
  "Noch keine Angebote im Vergleich mit Mitbewerbern": "No quotations compared with competitors yet",
  "Noch keine Auftragsbestätigung erfasst": "No order acknowledgement recorded yet",
  "Noch keine Bestellung mit bestätigtem Termin": "No order with confirmed date yet",
  "Noch keine Bestellungen oder Sendungen": "No orders or shipments yet",
  "Noch keine Bewertung": "No rating yet",
  "Noch keine Statusmeldungen.": "No status messages yet.",
  "Noch keine Tarife in dieser Zone.": "No rates in this zone yet.",
  "Noch keine Versanddienstleister": "No carriers yet",
  "Noch zu wenige Bestellungen und Angebote für eine Bewertung": "Too few orders and quotations for a rating",
  "Nur mit dem Recht „Einkaufspreise sehen“": "Only with the permission “See purchase prices”",
  "Oder Text einfügen": "Or paste text",
  "Ohne Abholanschrift kann der Dienstleister nicht abholen. Bitte zuerst die Bereitstellung ergänzen.": "Without a collection address the carrier cannot collect. Please complete the readiness first.",
  "Ohne Mailadresse: {liste}. Bitte im Dienstleister-Stamm ergänzen oder abwählen.": "Without email address: {liste}. Please add in the carrier master data or deselect.",
  "Ohne Schnittstelle: Verfolgung über den Link, Zustellung von Hand bestätigen.": "Without interface: track via the link, confirm delivery manually.",
  "PDF oder Foto lesen": "Read PDF or photo",
  "Packstück hinzufügen": "Add package",
  "Paket": "Parcel",
  "Paketdienste, Kuriere, Speditionen sowie Luft- und Seefracht mit Kundennummer, Abhol-Mail und Tarifen.": "Parcel services, couriers, forwarders as well as air and sea freight with account number, collection email and rates.",
  "Passwort": "Password",
  "Portal": "Portal",
  "Preis (€)": "Price (€)",
  "Preis netto (€)": "Net price (€)",
  "Preis {p} % über dem günstigsten": "Price {p} % above the cheapest",
  "Preis {p} ({q})": "Price {p} ({q})",
  "Preis {p}": "Price {p}",
  "Preis": "Price",
  "Preise aus den hinterlegten Tarifen (Herkunft Preisliste), netto ohne Zuschläge. Live-Preise der Dienstleister folgen mit eingerichteter Schnittstelle.": "Prices from the stored rates (source price list), net without surcharges. Live prices of the carriers follow once the interface is set up.",
  "Preise vergleichen": "Compare prices",
  "Preisliste": "Price list",
  "Preisniveau {p}": "Price level {p}",
  "Preisniveau": "Price level",
  "Preisrechner": "Price calculator",
  "Preisvergleich ausblenden": "Hide price comparison",
  "Problem gemeldet": "Problem reported",
  "Prüfen": "Review",
  "Punkte": "Score",
  "Punktzahl aus Liefertreue (45), Preisniveau (35) und AB-Reaktion (20); fehlende Teile zählen nicht": "Score from delivery reliability (45), price level (35) and acknowledgement response (20); missing parts do not count",
  "Reklamationen werden noch nicht erfasst": "Complaints are not yet recorded",
  "Reklamationen": "Complaints",
  "Schließen": "Close",
  "Schlüssel liegen verschlüsselt im Tresor der Datenbank und sind nur für die Serverprozesse lesbar. Ohne Zugang bleibt es beim Verfolgungslink und der manuellen Bestätigung, Abholungen gehen per Mail.": "Keys are stored encrypted in the database vault and can only be read by server processes. Without access, tracking uses the link and manual confirmation, collections are ordered by email.",
  "Schnittstelle Abholung": "Collection interface",
  "Schnittstelle Sendungsverfolgung": "Tracking interface",
  "Schnittstelle Verfolgung": "Tracking interface",
  "Schnittstelle vorbereitet": "Interface prepared",
  "Schnittstelle": "Interface",
  "Schwach": "Weak",
  "Secret": "Secret",
  "Seefracht": "Sea freight",
  "Sendung abgefragt: {m}": "Shipment queried: {m}",
  "Sendungen abgefragt: {m}": "Shipments queried: {m}",
  "Sendungen": "Shipments",
  "Sendungsnummer fehlt noch.": "Tracking number still missing.",
  "Sendungsverfolgung für DHL Paket, Express und Freight. API-Key aus dem DHL Developer Portal.": "Tracking for DHL Parcel, Express and Freight. API key from the DHL Developer Portal.",
  "Sendungsverfolgung über die FedEx Track API (OAuth).": "Tracking via the FedEx Track API (OAuth).",
  "Sendungsverfolgung über die UPS Tracking API (OAuth).": "Tracking via the UPS Tracking API (OAuth).",
  "Sendungsverfolgung": "Shipment tracking",
  "Spediteure": "Forwarders",
  "Spedition": "Road freight",
  "Speditionsanfrage an {name}": "Freight enquiry to {name}",
  "Speditionsanfrage {titel}": "Freight enquiry {titel}",
  "Speditionsanfrage": "Freight enquiry",
  "Speditionsanfragen": "Freight enquiries",
  "Speditionsauftrag an {name}": "Freight order to {name}",
  "Speichert …": "Saving …",
  "Stamm: {wert}": "Master data: {wert}",
  "Standard nach Name": "Default by name",
  "Status unbekannt": "Status unknown",
  "Statushistorie": "Status history",
  "Statusmeldung": "Status message",
  "Stornieren": "Cancel",
  "Stündlich alle offenen Sendungen mit Schnittstelle. Läufe unter": "Every hour, all open shipments with an interface. Runs under",
  "System": "System",
  "Tage vor dem bestätigten Liefertermin": "Days before the confirmed delivery date",
  "Tage über ETA oder erstem voraussichtlichem Termin": "Days beyond ETA or first estimated date",
  "Tage": "Days",
  "Tarif entfernen": "Remove rate",
  "Tarife": "Rates",
  "Testen": "Test",
  "Text der Bereitstellungsmeldung oder Packliste": "Text of the readiness notice or packing list",
  "Text mit {ki} lesen": "Read text with {ki}",
  "Text": "Text",
  "Titel": "Title",
  "Ungültige Ländercodes: {liste}. Bitte zweistellig, z. B. DE, NL.": "Invalid country codes: {liste}. Please use two letters, e.g. DE, NL.",
  "Unternehmen": "Company",
  "Verfolgung und Buchung": "Tracking and booking",
  "Verfolgungslink": "Tracking link",
  "Versanddienstleister": "Carriers",
  "Versandetiketten an den Lieferanten": "Shipping labels to the supplier",
  "Verspätung im Mittel {n} Tage": "Average delay {n} days",
  "Verzögert ab": "Delayed from",
  "Volumengewicht = Länge × Breite × Höhe in cm geteilt durch diesen Wert": "Volumetric weight = length × width × height in cm divided by this value",
  "Volumenteiler (cm³ je kg)": "Volume divisor (cm³ per kg)",
  "Volumenteiler": "Volume divisor",
  "Vom Lieferanten": "From the supplier",
  "Vorgabe des Unternehmens": "Company default",
  "Ware bereit": "Goods ready",
  "Werktage im Mittel aus {n} Auftragsbestätigung": "Working days on average from {n} order acknowledgement",
  "Werktage im Mittel aus {n} Auftragsbestätigungen": "Working days on average from {n} order acknowledgements",
  "Werktage nach der Bestellung, dann Warnung im Vorgang und Erinnerungsvorschlag": "Working days after the order, then warning in the case and reminder suggestion",
  "Werktage nach der letzten Erinnerung derselben Art": "Working days after the last reminder of the same type",
  "Wie im Unternehmen eingestellt": "As set for the company",
  "Zeitraum": "Period",
  "Ziel": "Destination",
  "Zielland": "Destination country",
  "Zone hinzufügen": "Add zone",
  "Zone löschen": "Delete zone",
  "Zone speichern": "Save zone",
  "Zone {name} gespeichert.": "Zone {name} saved.",
  "Zone {name} löschen?": "Delete zone {name}?",
  "Zone {n}": "Zone {n}",
  "Zone": "Zone",
  "Zonen und Tarife werden mit gelöscht. Sendungen behalten den Namen des Dienstleisters.": "Zones and rates are deleted as well. Shipments keep the carrier name.",
  "Zonen und Tarife": "Zones and rates",
  "Zugang eintragen": "Enter access",
  "Zugang entfernt.": "Access removed.",
  "Zugang gespeichert.": "Access saved.",
  "Zugang in den Einstellungen hinterlegen": "Store access in the settings",
  "Zugangsdaten je Mandant unter": "Access data per company under",
  "Zugänge der Versanddienstleister": "Carrier access",
  "Zurücknehmen": "Withdraw",
  "Zustand offen": "Condition open",
  "Zustand und Herkunft": "Condition and origin",
  "Zustand {p}": "Condition {p}",
  "Zustand {z}": "Condition {z}",
  "Zustand, Ursprung und Zolltarifnummer in den Artikelstamm übernehmen (überschreibt vorhandene Werte)": "Transfer condition, origin and customs tariff number to the article master (overwrites existing values)",
  "ab {datum}": "from {datum}",
  "ab {p}": "from {p}",
  "abgebrochen": "cancelled",
  "abgelehnt": "declined",
  "abholbereit": "ready for collection",
  "angefragt": "requested",
  "angekündigt": "announced",
  "angelegt": "created",
  "aus Mail": "from email",
  "aus PDF": "from PDF",
  "beauftragt": "ordered",
  "bei Versand": "on dispatch",
  "bei Verzögerung": "on delay",
  "bei Zustellung": "on delivery",
  "bestellt {datum}": "ordered {datum}",
  "bis kg": "up to kg",
  "eingefügtem Text": "pasted text",
  "erinnert {zeit}": "reminded {zeit}",
  "gesetzt {zeit}": "set {zeit}",
  "getestet {zeit}": "tested {zeit}",
  "gewählt": "selected",
  "günstigster Preis": "lowest price",
  "günstigstes": "cheapest",
  "hinterlegt {h}": "stored {h}",
  "im gewählten Zeitraum, ohne stornierte": "in the selected period, excluding cancelled",
  "in Zustellung": "out for delivery",
  "je weiteres kg (€)": "per additional kg (€)",
  "je weiteres kg": "per additional kg",
  "kein Tarif": "no rate",
  "keine Mailadresse": "no email address",
  "keine, Abholauftrag per Mail": "none, collection order by email",
  "keine, nur Link": "none, link only",
  "keine, per Mail": "none, by email",
  "kg": "kg",
  "kürzeste Lieferzeit": "shortest lead time",
  "live": "live",
  "neu": "new",
  "nicht eingerichtet": "not set up",
  "noch nicht gesendet": "not sent yet",
  "noch {n} Spediteur": "{n} forwarder left",
  "noch {n} Spediteure": "{n} forwarders left",
  "ohne Bewertung": "not rated",
  "ohne Sendungsnummer": "without tracking number",
  "schnellste": "fastest",
  "schnellstes": "fastest",
  "seit {n} Werktag": "since {n} working day",
  "seit {n} Werktagen": "since {n} working days",
  "verzögert": "delayed",
  "von Hand": "manual",
  "voraussichtlich {datum}": "estimated {datum}",
  "wie E-Mail": "same as email",
  "z. B. Stapler vorhanden, Hebebühne nötig": "e.g. forklift available, tail lift required",
  "z. B. Zoll freigegeben": "e.g. customs cleared",
  "{a} ohne Zugang": "{a} without access",
  "{ki} liest …": "{ki} is reading …",
  "{name} beauftragt, Sendung angelegt.": "{name} ordered, shipment created.",
  "{name} löschen?": "Delete {name}?",
  "{name} wählen": "Select {name}",
  "{n} Angebot": "{n} quotation",
  "{n} Angebote": "{n} quotations",
  "{n} Bestellung ohne AB nach Frist": "{n} order without acknowledgement after deadline",
  "{n} Bestellungen ohne AB nach Frist": "{n} orders without acknowledgement after deadline",
  "{n} Erinnerung gesendet": "{n} reminder sent",
  "{n} Erinnerungen gesendet": "{n} reminders sent",
  "{n} Gewichtsstufe": "{n} weight band",
  "{n} Gewichtsstufen": "{n} weight bands",
  "{n} Mal erinnert, zuletzt {zeit}": "reminded {n} times, last {zeit}",
  "{n} Spediteur": "{n} forwarder",
  "{n} Spediteure": "{n} forwarders",
  "{n} Tag": "{n} day",
  "{n} Werktag drüber": "{n} working day overdue",
  "{n} Werktage drüber": "{n} working days overdue",
  "{n} cm³ je kg": "{n} cm³ per kg",
  "{p} Punkte": "{p} points",
  "{p} von {n} bis zum bestätigten Termin": "{p} of {n} by the confirmed date",
  "Öffnungszeiten": "Opening hours",
  "Über Schnittstelle buchen": "Book via interface",
  "Überholt": "Reconditioned",
  "überholt": "reconditioned",
  "Keine Zone für dieses Land": "No zone for this country",
  "Keine Tarife hinterlegt": "No rates stored",
  "Gewicht über dem höchsten Tarif": "Weight above the highest rate",
  "Volumengewicht maßgeblich": "Volumetric weight applies",
  "Offene Sendungen beim Versanddienstleister abfragen, Zustellung und Verzögerung erkennen, Kunden benachrichtigen": "Query open shipments with the carrier, detect delivery and delays, notify customers",
  "stündlich": "hourly",
} satisfies Record<string, string>;
